/** Sitios donde el backend exige guía de tallas (alineado con mlSizeGridHelper). */
export const SIZE_GRID_REQUIRED_SITES = ["MCO"];

/** La categoría declara SIZE_GRID_ID (se muestra el campo). */
export const categoryRequiresSizeGrid = (categoryAttributes = []) =>
  Array.isArray(categoryAttributes) &&
  categoryAttributes.some((attribute) => attribute && attribute.id === "SIZE_GRID_ID");

/**
 * Obligatorio solo si hay grids disponibles del sitio que lo exige (MCO).
 * Sin opciones (ej. MLV / Venezuela) se muestra el campo pero no bloquea.
 */
export const isSizeGridMandatory = (categoryAttributes = [], availableSizeGrids = []) => {
  if (!categoryRequiresSizeGrid(categoryAttributes)) return false;
  if (!Array.isArray(availableSizeGrids) || !availableSizeGrids.length) return false;

  return availableSizeGrids.some((grid) =>
    SIZE_GRID_REQUIRED_SITES.includes(String((grid && grid.site_id) || "").toUpperCase())
  );
};

export const getProductsMissingSizeGrid = (
  products = [],
  categoryAttributes = [],
  availableSizeGrids = []
) => {
  if (!isSizeGridMandatory(categoryAttributes, availableSizeGrids)) return [];

  return products.filter((product) => !String((product && product.sizeGridId) || "").trim());
};
